import { lazy } from 'react';

// project imports
import AuthGuard from 'utils/route-guard/AuthGuard';
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

// sample page routing
const Dashboard = Loadable(lazy(() => import('views/superuser/dashboard')));

const OrganizationsScreen = Loadable(lazy(() => import('views/superuser/organizations/OrganizationsScreen')));
const ArchivedOrganizationsScreen = Loadable(lazy(() => import('views/superuser/organizations/ArchivedOrganizationsScreen')));
const OrganizationScreen = Loadable(lazy(() => import('views/superuser/organizations/OrganizationScreen')));

const SuperOrganizationsScreen = Loadable(lazy(() => import('views/superuser/super-organizations/SuperOrganizationsScreen')));
const ArchivedSuperOrganizationsScreen = Loadable(lazy(() => import('views/superuser/super-organizations/ArchivedSuperOrganizationsScreen')));

const SuperuserReportPage = Loadable(lazy(() => import('views/superuser/reports/SuperuserReport')));
//const OrganizationScreen = Loadable(lazy(() => import('views/superuser/organization/OrganizationScreen')));

//update password
const UpdatePasswordPage = Loadable(lazy(() => import('views/shared/update-password')));

//configure 2fa
const ConfigureTwoFactorSettingsPage = Loadable(lazy(() => import('views/shared/configure-2fa-settings/ConfigureTwoFactorSettings')));
// ==============================|| MAIN ROUTING ||============================== //

const SuperuserRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: '/',
            element: <Dashboard />
        },
        {
            path: '/dashboard',
            element: <Dashboard />
        },
        {
            path: '/organizations',
            element: <OrganizationsScreen />,
        },
        {
            path: '/archivedOrganizations',
            element: <ArchivedOrganizationsScreen />,
        },
        {
            path: '/organizations/edit',
            element: <OrganizationScreen />
        },
        {
            path: '/organizations/create',
            element: <OrganizationScreen />
        },
        {
            path: '/super-organizations',
            element: <SuperOrganizationsScreen />,
        },
        {
            path: '/archivedSuperOrganizations',
            element: <ArchivedSuperOrganizationsScreen />,
        },
        {
            path: '/report/superuser',
            element: <SuperuserReportPage />,
        },
        {
            path: '/user/update-password',
            element: <UpdatePasswordPage />
        },
        {
            path: '/2fa-settings',
            element: <ConfigureTwoFactorSettingsPage />
        },
    ]
};

export default SuperuserRoutes;
